
import {
    SEARCH_TEXT,
    SEARCH_TYPE,
    GET_SEARCH_DATA,
    GET_SEARCH_CONTESTANTS_DATA_SUCCESS,
    GET_SEARCH_CONTEST_DATA_SUCCESS,
    GET_SEARCH_VOTER_DATA_SUCCESS,
} from '../constants/actionTypes';

export const searchText = (payload) => ({
    type: SEARCH_TEXT,
    payload
});

export const searchType = (payload) => ({
    type: SEARCH_TYPE,
    payload
});

export const getSearchData = (payload) => ({
    type: GET_SEARCH_DATA,
    payload
});

export const getSearchContestantsDataSuccess = (payload) => ({
    type: GET_SEARCH_CONTESTANTS_DATA_SUCCESS,
    payload
});

export const getSearchContestDataSuccess = payload => ({
    type: GET_SEARCH_CONTEST_DATA_SUCCESS,
    payload
});

export const getSearchVoterDataSuccess = payload => ({
    type: GET_SEARCH_VOTER_DATA_SUCCESS,
    payload
});